export const reducer = (state, action) => {

    switch (action.type) {
        case "START_LOGIN":
            return {
                ...state,
                loading: true
            }

        case "LOGIN_SUCCESS":
            return {
                ...state,
                isAuth: true,
                token: action.payload.token,
                avatar : action.payload.avatar,
                loading: false
            }

        case "LOGIN_ERROR":
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case "LOGOUT":
            return {
                isAuth: false,
                token: null,
                loading: false,
                avatar:null
            }

        default:
            return state
    }

}